module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.855b4867.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Bold.woff
// module id = 349
// module chunks = 3